export function getChartOfAccountAssociation (cellParams) {
  console.log('getChartOfAccountAssociation', cellParams)

  // The entity Id of the column
  const columnAccountingOrganisationId = cellParams.colDef.context.accountingOrganisation.id
  console.log('columnAccountingOrganisationId', columnAccountingOrganisationId)

  const valuesByAccountingOrganisationId = cellParams.data.valuesByAccountingOrganisationId.get(columnAccountingOrganisationId)
  console.log('valuesByAccountingOrganisationId', valuesByAccountingOrganisationId)
  if (!valuesByAccountingOrganisationId) {
    return {
      associatedChartOfAccount: null,
      entity: null
    }
  }

  const associatedChartOfAccount = valuesByAccountingOrganisationId[0]?.associatedChartOfAccount
  const associatedEntity = valuesByAccountingOrganisationId[0]?.associatedEntity
  console.log('associatedEntity', associatedEntity)
  return {
    associatedChartOfAccount,
    entity: associatedEntity
  }
}
